import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUnAssignPersonalCalendarHolidaysRequestFailure({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isFailure : false;
    },
    isUnAssignPersonalCalendarHolidaysRequestPending({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isPending : false;
    },
    isUnAssignPersonalCalendarHolidaysRequestSuccess({ uuid }) {
      const state = getState().find(({ resource }) => uuid === resource.uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
